import React, { useEffect, useState } from 'react';
import { Tooltip } from 'src/component/Global/Tooltip';
import System from 'src/helper/system';
import { useBOMStore } from 'src/hooks/bom';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import factoryLeadIcon from "src/assets/images/factory-lead-icon.svg";
import HelperAdobeEvent from 'src/support/HelperAdobeEvent';
import Constants from 'src/helper/Constants';

const BomNewarkList = (props) => {
    const [{ newark_bom_list }, { fetch_Newark_bom_list }, { update_Newark_Qte }] = useBOMStore();
    const [__check] = useAxiosIndicatorCheck();
    const { bomDetail, bomInfo } = props;
    const [checkedItems, setCheckedItems] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [newarkFormData, setNewarkFormData] = useState('');
    const [pricingVisibility, setPricingVisibility] = useState({});
    const [validCount, setValidCount] = useState(0);
    const bom_id = System.getParams().bomId;
    const url = System.getNewarkURL();

    useEffect(() => {
        fetch_Newark_bom_list(bom_id);
    }, []);

    const handleCheckboxChange = (sku) => {
        setCheckedItems((prevState) => ({ ...prevState, [sku]: !prevState[sku], }));
    };

    const handleSelectAllChange = () => {
        const newSelectAll = !selectAll;
        setSelectAll(newSelectAll);
        setCheckedItems(newSelectAll ? newark_bom_list?.manufacturerPartNumberSearchReturn?.products.reduce((acc, product) => ({ ...acc, [product.sku]: true }), {}) : {});
    };

    const prepareFormData = (products) => {

        const selectedItems = products
            .map((prod) => {
                if (prod) {
                    return {
                        MANUFACTURER_PID: prod.translatedManufacturerPartNumber,
                        QUANTITY: prod.translatedMinimumOrderQuality.toString(),
                        SUPPLIER_ID_DUNS: 'Avnet',
                    };
                }
                return null;
            })
            .filter(Boolean);

        if (selectedItems.length > 0) {
            setNewarkFormData(JSON.stringify({ ITEM: selectedItems }));
        }
    };


    const handleSubmit = async () => {

        addItemsToNewarkEvent();
        //  window.open('https://www.newark.com/', '_blank');
        // console.log('newarkFormData', newarkFormData)
        console.log('newarkFormData', newarkFormData)
        document.getElementById("networkSubmit")?.click();

    };


    const getNearestMultiple = (num, from, to) => num >= from && num <= to;

    const togglePricing = (sku) => {
        setPricingVisibility((prevState) => ({
            ...prevState,
            [sku]: !prevState[sku],
        }));
    };

    useEffect(() => {
        if (!newark_bom_list?.manufacturerPartNumberSearchReturn || !checkedItems) return;

        const validCheckedItems = Object.entries(checkedItems).filter(([sku, isChecked]) => isChecked).map(([sku]) => sku);

        const validProducts = validCheckedItems.map((sku) => {
            return newark_bom_list?.manufacturerPartNumberSearchReturn.products.find((prod) => prod.sku === sku && !prod.qtyError);
        }).filter(Boolean);

        setValidCount(validProducts.length);
        prepareFormData(validProducts);

    }, [newark_bom_list, checkedItems]);

    const addItemsToNewarkEvent = () => {
        let selectedItems = Object.entries(checkedItems).filter(([sku, isChecked]) => isChecked).map(([sku]) => sku).map((sku) => {
            return newark_bom_list?.manufacturerPartNumberSearchReturn.products.find((prod) => prod.sku === sku && !prod.qtyError);
        }).filter(Boolean);
        if (selectedItems?.length > 0) {
            localStorage.setItem("adobeEventType", Constants.analyticsEvent.ADD_NEWARK_ITEM);
            let bomDetails = { ...bomInfo, exactMatchCount: newark_bom_list?.manufacturerPartNumberSearchReturn?.numberOfResults, nomatchCount: bomDetail?.NoMatch?.count, multipleMatchCount: bomDetail?.Multiple?.count }
            selectedItems = selectedItems.map((x) => {
                let price = getCostForQuantity(x, Number(x.translatedMinimumOrderQuality));
                if (price) {
                    return { ...x, subTotal: price, unitPrice: price }
                }
                return x;
            });
            HelperAdobeEvent.trackingAdobeEvent({ prodDetails: selectedItems, bomDetails: bomDetails });
        }
    }

    const getCostForQuantity = (product, qty) => {
        if (!product || !product.prices || !Array.isArray(product.prices)) {
            return null;
        }

        const priceTier = product.prices.find(price => qty >= price.from && qty <= price.to);
        return priceTier ? priceTier.cost : null;
    }




    return (
        <>
            <div className="d-flex justify-content-between align-items-end bb4">
                <div className="mobile-tab bom-tab">
                    <ul className="bs5 nav nav-tabs border-bottom-0">
                        <li className="maxw-auto">
                            <a className="w-auto text-uppercase font-bold active" href={void (0)}>
                                <i className="fa fa-check-circle me-1 text-darkgreen font-16" />
                                <span>Exact Match</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="tabs-text-top align-self-center d-none d-lg-block">
                    <button
                        className="bs5 btn btn-secondary mb-3 mb-md-0"
                        onClick={handleSubmit}
                        disabled={!validCount}
                    >
                        Add item({validCount}) in Newark <i className="fa fa-shopping-cart ms-1" />
                    </button>
                </div>
            </div>

            <div className="tab-pane active table-container">
                <div id="sticky-table-wrapper" className="floating-table table-responsive mb-0 sticky-table-wrapper">
                    {__check(['BOM_NEWARK_LIST_API_CALL'], { overlay: true }).render}

                    <table id="bomexactmatch-table" className="bs5 table table-bordered table-exact-match">
                        <thead>
                            <tr>
                                <th className="w-85"></th>
                                <th className="text-nowrap">
                                    <div className="form-check font-15 d-flex align-items-center ps-0">
                                        <input
                                            type="checkbox"
                                            checked={newark_bom_list?.manufacturerPartNumberSearchReturn?.numberOfResults && newark_bom_list?.manufacturerPartNumberSearchReturn?.products?.every(product => checkedItems[product.sku])}
                                            className="form-check-input parent-check-input ps-0 ms-0"
                                            onChange={handleSelectAllChange}
                                            disabled={!newark_bom_list?.manufacturerPartNumberSearchReturn?.numberOfResults}
                                        />
                                    </div>
                                </th>
                                <th className="text-nowrap w220">Matched Part Number</th>
                                <th className="text-nowrap w150">Quantity</th>
                                <th className="text-nowrap w160">Price</th>
                                <th className="text-nowrap w290">Availability</th>
                                <th className="text-nowrap">Manufacturer</th>
                                <th className="text-nowrap">Line Note</th>
                                <th className="text-nowrap w200">Newark Part Number</th>
                            </tr>
                        </thead>
                        <tbody>
                            {newark_bom_list?.manufacturerPartNumberSearchReturn?.products?.map((product, index) => (
                                <tr key={product.sku}>
                                    <td><span className="index-count">{index + 1}</span></td>
                                    <td className=''>
                                        <input className='form-check-input parent-check-input ps-0 ms-0'
                                            type="checkbox"
                                            checked={checkedItems[product.sku]}
                                            onChange={() => handleCheckboxChange(product.sku)}
                                        />
                                    </td>
                                    <td> <b>{product.translatedManufacturerPartNumber}</b> <div className='d-block'> ({product.vendorName})</div></td>
                                    <td>
                                        <input
                                            className={product.qtyError ? "form-control form-control-sm hidearrow error" : "form-control form-control-sm hidearrow"}
                                            value={product.translatedMinimumOrderQuality}
                                            onChange={(e) => update_Newark_Qte({ sku: product.sku, value: e.target.value })}
                                            type="number"
                                            onKeyDown={(event) => {
                                                if (['e', 'E', '+', '-', '.'].includes(event.key)) {
                                                    event.preventDefault();
                                                }
                                                if (event.key === 'ArrowDown') {
                                                    const newValue = parseInt(event.target.value, 10);
                                                    if (newValue <= 0) {
                                                        event.preventDefault();
                                                    }
                                                }
                                            }}
                                        />
                                        <span class="mandatory"> {product.qtyError && "Invalid Quantity"}</span>
                                    </td>
                                    <td>
                                        {product.prices?.length > 0 && (
                                            <>
                                                <div className='price-table-list'>
                                                    {product.prices.slice(0, 3).map((price, index) => (
                                                        <div key={index} className='price-table-list'>
                                                            <div className={getNearestMultiple(product.translatedMinimumOrderQuality, price.from, price.to) ? 'bs5 row mx-0 font-bold' : 'bs5 row mx-0'}>
                                                                <div className='ps-0 col-6 font-12'>
                                                                    <span>{price.from}+</span>
                                                                </div>
                                                                <div className='pe-0 col-6 text-end font-12'>
                                                                    <span>${price.cost}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    {product.prices.length > 3 && !pricingVisibility[product.sku] && (
                                                        <a onClick={() => togglePricing(product.sku)} className='text-blue2 d-flex mt-1'>
                                                            <span class="font-bold font-12">More Pricing </span>
                                                            <i class="fa fa-angle-down font-bold font-18 ms-1"></i>
                                                        </a>
                                                    )}
                                                    {pricingVisibility[product.sku] && (
                                                        <>
                                                            {product.prices.slice(3).map((price, index) => (
                                                                <div key={index + 3}>
                                                                    <div className={getNearestMultiple(product.translatedMinimumOrderQuality, price.from, price.to) ? 'bs5 row mx-0 font-bold' : 'bs5 row mx-0'}>
                                                                        <div className='ps-0 col-6 font-12'>
                                                                            <span>{price.from}+</span>
                                                                        </div>
                                                                        <div className='pe-0 col-6 text-end font-12'>
                                                                            <span>${price.cost}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                            <a onClick={() => togglePricing(product.sku)} className='text-blue2 d-flex mt-1'>
                                                                <span class="font-bold font-12">Less Pricing  </span>
                                                                <i class="fa fa-angle-up font-bold font-16 ms-1"></i>
                                                            </a>
                                                        </>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </td>
                                    <td>
                                        <div className="text-darkgreen d-flex align-items-center">
                                            <span className="d-flex text-darkgreen w-100">
                                                <b>In Stock</b>
                                                <b className="ms-auto">{product.stock.level}</b>
                                                <i className="fa fa-check-circle ms-2 font-14"></i>
                                            </span>
                                        </div>

                                        <div id="availability_cont_3_lead_time" className="grey">
                                            <div className="addtn-inventory leadTime">
                                                <strong>ADDITIONAL INVENTORY</strong>
                                                <div className="clearfix">
                                                    <div className='factory-lead'>
                                                        <div className='additional-title w-100 d-flex'>
                                                            {<img className={'me-1'} src={factoryLeadIcon}></img>}

                                                            Factory Lead Time:
                                                            <Tooltip
                                                                opener={() => <i className='fa fa-exclamation-circle' />}
                                                                content={() => <>
                                                                    {product.stock.leastLeadTime ?
                                                                        'For quantities exceeding available inventory, your estimated delivery is based on supplier lead time, shipping method and destination.'
                                                                        : ' Factory Lead Time: Lead time unavailable'}
                                                                </>}
                                                            />
                                                            <div className='ms-auto'>
                                                                {product.stock.leastLeadTime ?
                                                                    System.daysToWeeksAndDays(product.stock.leastLeadTime) : 'Lead time unavailable'}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{product.vendorName}</td>
                                    <td>{product.productOverview?.warnings}</td>
                                    <td>{product.sku}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <form className="d-none" target="_blank" action={url} id="farnellcart" method="post" name="farnellcart" >
                <input id="result" name="result"
                    value={newarkFormData}
                />
                <input type="submit" value="Farnell Cart" id="networkSubmit" />
            </form>
        </>
    );
};

export default BomNewarkList;
